module.exports = __webpack_public_path__ + "assets/img/iron-shield.2e8cb4b3.png";